import { AuthGuard } from "@frontend/components/auth/AuthGuard"
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@frontend/components/ui/resizable"
import type { ReactNode } from "react"
import { Outlet } from "react-router"

import { SidebarContainer } from "./Sidebar"
import { TopbarContainer } from "./Topbar"

interface AppLayoutViewProps {
  topbar: ReactNode
  sidebar: ReactNode
  content: ReactNode
}

export function AppLayoutView({ topbar, sidebar, content }: AppLayoutViewProps) {
  return (
    <div className="flex flex-col h-screen bg-background">
      {topbar}
      <ResizablePanelGroup orientation="horizontal" className="flex-1 min-h-0">
        <ResizablePanel defaultSize={18} minSize={8} className="flex flex-col">
          {sidebar}
        </ResizablePanel>
        <ResizableHandle withHandle />
        <ResizablePanel defaultSize={82} minSize={30}>
          <main className="h-full overflow-auto bg-surface-sunken p-6">{content}</main>
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  )
}

export function AppLayoutContainer() {
  return (
    <AuthGuard>
      <AppLayoutView topbar={<TopbarContainer />} sidebar={<SidebarContainer />} content={<Outlet />} />
    </AuthGuard>
  )
}

export const AppLayout = AppLayoutContainer
